///-- THIS FILE IS GENERATED --///
export enum BorderCollapse {

    BORDER_COLLAPSE = "pinata-border-collapse",

    BORDER_SEPARATE = "pinata-border-separate",

}